import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseModel } from 'src/app/shared/models/ResponseModel';
import { environment } from 'src/environments/environment';
import { MiAdmPersonasAcademicos } from '../interfaces/IAdmPersonAcademic';
import { MiAdmPersonWorking } from '../interfaces/IAdmPersonWorking';

@Injectable({
  providedIn: 'root'
})
export class PersonWorkingService {
  private apiUrl = environment.backUrlApi + 'PersonWorking';
  private http = inject(HttpClient);

  /** Obtener todos los registros académicos */
  getAll(): Observable<ResponseModel<MiAdmPersonWorking[]>> {
    return this.http.get<ResponseModel<MiAdmPersonWorking[]>>(`${this.apiUrl}`);
  }

  /** Crear registro académico completo */
  createFull(id: string, body: MiAdmPersonWorking): Observable<ResponseModel<MiAdmPersonWorking>> {
    return this.http.post<ResponseModel<MiAdmPersonWorking>>(`${this.apiUrl}/create-full?id=${id}`, body);
  }

  /** Obtener registros académicos por Id */
  getById(id: string): Observable<ResponseModel<MiAdmPersonWorking[]>> {
    return this.http.get<ResponseModel<MiAdmPersonWorking[]>>(`${this.apiUrl}/by-id?id=${encodeURIComponent(id)}`);
  }

  /** Eliminar registro académico por Id */
  delete(idEncrypted: string, idDeleted: string): Observable<ResponseModel<MiAdmPersonWorking>> {
    return this.http.delete<ResponseModel<MiAdmPersonWorking>>(
      `${this.apiUrl}/delete?idEncrypted=${encodeURIComponent(idEncrypted)}&idDeleted=${idDeleted}`
    );
  }
  updateFull(id: string, body: MiAdmPersonWorking): Observable<ResponseModel<MiAdmPersonWorking>> {
    return this.http.put<ResponseModel<MiAdmPersonWorking>>(`${this.apiUrl}/update-full?id=${id}`, body);
  }
}
